
// Main Layout Container CSS - Used for all main content boxes
export const layoutCSS = {
  bgcolor: "rgba(255, 255, 255, 0.07)", // More transparent white for better background visibility
  boxShadow: 3,
  margin: 0,
  padding: 1.5,
  width: "100%",
  maxWidth: "100vw",
  minHeight: "calc(100vh - 24px)",
  overflow: "hidden",
  borderRadius: 0.2,
  fontSize: "0.8rem"
};

// Form Box Container - Used for form wrappers
export const formBoxCSS = {
  mt: 1,
  p: 4,
  width: "100%",
  borderRadius: 5,
  bgcolor: "rgba(255, 255, 255, 0)",
};

// Table Cell Styling - Standard cell style with bottom border
export const cellSX = {
  padding: '6px',
  fontSize: '0.8rem',
  borderRight: '0.5px solid #0f0f0fff',
};

// Table Header Styling - Blue background with white text
export const tableHeaderSX = {
  bgcolor: "#0288d1",
  "& th": {
    color: "white",
    fontSize: "0.75rem",
    borderBottom: "0.5px solid #1f1e1eff",
  },
};

// TextField Input Field CSS - For standard text inputs with small size
export const textFieldCSS = {
  width: "30%",
  "& .MuiInputBase-input": {
    fontSize: "0.75rem",
  },
  "& .MuiInputLabel-root": {
    fontSize: "0.75rem",
  },
};

// Smaller TextField for compact forms
export const textFieldSmallCSS = {
  "& .MuiInputBase-input": {
    fontSize: "0.75rem",
  },
  "& .MuiInputLabel-root": {
    fontSize: "0.75rem",
  },
};

// FormControl Styling - For select dropdowns and form controls
export const formControlCSS = {
  width: "30%",
  size: "small",
};

// Select Menu Styling - For dropdown select components
export const selectCSS = {
  height: 35,
  border: "1px solid #000000ff",
  fontSize: "0.8rem",
  textTransform: "none",
  "& .MuiSelect-select": {
    fontSize: "0.8rem",
    textAlign: "center",
  },
};

// MenuItem Styling - For dropdown menu items
export const menuItemCSS = {
  fontSize: "0.75rem",
};

// Button Styling - Standard button style matching theme
export const buttonCSS = {
  textTransform: "none",
  fontSize: "0.85rem",
  height: 35,
};

// Upload/File Button Styling
export const uploadButtonCSS = {
  width: "30%",
  height: 35,
  textTransform: "none",
  fontSize: "0.85rem",
  justifyContent: "flex-start",
  overflow: "hidden",
};

// Container Row with flexbox - For spacing input fields
export const containerRowCSS = {
  display: "flex",
  gap: 2,
  flexWrap: "wrap",
};

// Text Color - Primary text color for labels and headings
export const textColorCSS = {
  color: "#333",
};

// Secondary Text Color - For helper text and secondary labels
export const secondaryTextCSS = {
  color: "#666",
  fontSize: "0.75rem",
};

// Error Text Color
export const errorTextCSS = {
  color: "#d32f2f",
  fontSize: "0.75rem",
};

// ===== COLOR CONSTANTS =====
export const COLORS = {
  WHITE: "#fff",
  SMOKE_WHITE: "#F5F5F5", // Light gray-white for text visibility
  SEMI_WHITE: "rgba(255, 255, 255, 0.7)", // White with 70% opacity
  DARK_TEXT: "#333",
  LIGHT_TEXT: "#666",
  ERROR: "#d32f2f",
};

// ===== INPUT FIELD STYLES WITH BACKGROUNDS =====
// Compact TextField - White background with proper text contrast
export const compactTextFieldSX = {
  "& .MuiInputBase-root": {
    height: 34,
    fontSize: "0.75rem",
    backgroundColor: COLORS.WHITE,
  },
  "& .MuiInputLabel-root": {
    fontSize: "0.7rem",
    color: COLORS.DARK_TEXT,
  },
  "& .MuiOutlinedInput-root": {
    backgroundColor: COLORS.WHITE,
  },
};

// Compact Select - White background with proper dropdown styling
export const compactSelectSX = {
  backgroundColor: COLORS.WHITE,
  fontSize: "0.75rem",
  height: 34,
  "& .MuiSelect-select": {
    backgroundColor: COLORS.WHITE,
  },
};

// Input field for dark backgrounds - Use smoke white for visibility
export const contrastTextFieldSX = {
  "& .MuiInputBase-root": {
    height: 34,
    fontSize: "0.75rem",
    backgroundColor: COLORS.SMOKE_WHITE,
  },
  "& .MuiInputLabel-root": {
    fontSize: "0.7rem",
    color: COLORS.DARK_TEXT,
  },
};

// Input field with semi-transparent white - For layered backgrounds
export const semiTransparentFieldSX = {
  "& .MuiInputBase-root": {
    backgroundColor: COLORS.SEMI_WHITE,
  },
  "& .MuiOutlinedInput-root": {
    backgroundColor: COLORS.SEMI_WHITE,
  },
};
export const cellSXS = {
  fontSize: "0.75rem",
  padding: "4px 6px",        // 👈 reduce padding
  whiteSpace: "nowrap",      // 👈 no wrap
  overflow: "hidden",
  textOverflow: "ellipsis",  // 👈 ...
  maxWidth: 120,             // 👈 default max width
};